import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import { toast } from "react-hot-toast";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import Select from "react-select";

const TransactionCatUpdater = (props) => {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState("");
  const [data, setData] = useState(props.item);
  const [cost_allocations, setCost_allocations] = useState(
    props.cost_allocations
  );
  console.log(data);

  const [cost_item, setCost_item] = useState("");
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);

  const handleAdd = async (e, controls) => {
    e.preventDefault();

    // Ensure data and data.cat_balance are defined before accessing
    if (
      !data ||
      !data.cat_balance ||
      cost_item.trim() === "" ||
      parseFloat(amount) > parseFloat(data.cat_balance.cat_balance)
    ) {
      toast.error(
        "Please complete all fields and ensure the amount does not exceed the available balance."
      );
      return;
    } else {
      setLoading(true);

      const payload = {
        reference: props.reference,
        cost_item: cost_item,
        amount: amount,
        description: description,
        date: date,
      };
      const server_response =
        await ajaxAccounting.setPaymentVoucher_costAllocation(payload);

      setLoading(false);
      if (server_response.status === "OK") {
        controls.close();
        toast.success(server_response.message);
        props.function();
      } else {
        toast.error(server_response.message);
      }
    }
  };

  const RenderFooter = (controls) => {
    if (loading) {
      return <Loader />;
    } else {
      return (
        <>
          <button
            className="btn ripple btn-dark"
            type="button"
            onClick={controls.close}
          >
            Close
          </button>
          <button
            type="button"
            disabled={loading}
            className={`btn ripple btn-success`}
            onClick={(e) => handleAdd(e, controls)}
          >
            Save changes
          </button>
        </>
      );
    }
  };

  return (
    <SystemModal
      title="Transaction cost allocation item"
      id="model-new-ledger"
      size="lg"
      footer={RenderFooter}
    >
      <div
        className="mb-4 col-md-12"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          borderBottom: "dotted 1px grey",
          backgroundColor: "transparent",
        }}
      >
        <div className="">
          <ul>
            <li>
              <span>
                Account_debited:{" "}
                <u>{data && data.ledgerID_debited.Ledger_name}</u>
              </span>
            </li>
            <li>
              <span>
                Account_credited:{" "}
                <u>{data && data.ledgerID_credited.Ledger_name}</u>
              </span>
            </li>
          </ul>
        </div>
        <div className="">
          <ul>
            <li>
              <span>
                Total_of_transaction: <u>{data && data.amount.amount_c}</u>
              </span>
            </li>
            <li>
              <span>
                amount_un_Allocated:{" "}
                <u>{data && data.cat_balance.cat_balance_c}</u>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="mb-4 col-md-12">
        <label htmlFor="">
          select cost allocation item:<span className="tx-danger">*</span>
        </label>

        <Select
          onChange={(e) => setCost_item(e.id)}
          getOptionLabel={(option) => option.item}
          getOptionValue={(option) => option.id}
          isSearchable
          options={Array.isArray(cost_allocations) ? cost_allocations : [""]}
          value={
            Array.isArray(cost_allocations) &&
            cost_allocations.find((value) => value.id === cost_item)
          }
        />
      </div>
      <div className="mb-4 col-md-12">
        <label htmlFor="">
          Amount
          <span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="text"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="form-control"
        />
      </div>
      <div className="mb-4 col-md-12">
        <label htmlFor="">
          Date
          <span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="form-control"
        />
      </div>
      <div className="mb-4 col-md-12">
        <label htmlFor="">
          Description
          <span style={{ color: "red" }}>*</span>
        </label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="form-control"
        ></textarea>
      </div>
    </SystemModal>
  );
};

export default TransactionCatUpdater;
